import { render } from "./Video.vue?vue&type=template&id=73fbc623&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"

import "./Video.vue?vue&type=style&index=0&id=73fbc623&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-73fbc623"

export default script